module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot5-d6edbadb063109624b66870640c851e1.png";